import { render, staticRenderFns } from "./ConferenceDetail.vue?vue&type=template&id=2e723120&scoped=true"
import script from "./ConferenceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConferenceDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConferenceDetail.vue?vue&type=style&index=0&id=2e723120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e723120",
  null
  
)

export default component.exports